import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper";

// Service
import {
  CreateBoards,
  GetBoardsById,
  UpdateBoards
} from "./services/Boards.js"

import {
  SearchPageDetail,
  SavePageDetail,
  UpdatePageDetail,
} from "../../services/api/module/PageSetting.js"

import { CreatePreview } from "services/api/module/PreviewData"

import configWebRoute from "services/api/configWebRoute"
import Error401 from "components/Error401"

const wr = configWebRoute

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const _routeLink = `executives-and-boards/board-of-directors`;
const _pageName = `Board of Directors`
const _parentComponent = wr.EXECUTIVES_AND_BOARDS
const _routePermission = `executives-and-boards:board-of-directors`

const BoardTemplate = ({ pageView = "create", componentKey = "" }) => {
  // POPUP
  const { mAlert } = useContext(ModalContext)

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? "TH"
  const qMainId = qParams.id
  const navigate = useNavigate()

  const [waitSendData, setWaitSendData] = useState(false)
  const [contentLoading, setContentLoading] = useState(false)
  const [prefillComplete, setPrefillComplete] = useState()
  const [contentDetail, setContentDetail] = useState()
  const [pageDetail, setPageDetail] = useState()
  const [currentSlug, setCurrentSlug] = useState()
  const [waitCreatePreview, setWaitCreatePreview] = useState(false)

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    contentName: Yup.string().max(255).required("Please Enter Site Name"),
    contentPosition: Yup.string().required("Please Enter Position"),
    slug: Yup.string().max(255).required("Please Enter Slug"),
    contentDetail: Yup.string().required("Please Enter Detail"),

    thumbnail: Yup.object().test(
      "is-not-empty-object",
      "Please Upload Thumbnail",
      (value) => value && Object.keys(value).length > 0
    ).required("Please Upload thumbnail"),

    contentSeoTitle: Yup.string(),
    contentSeoKeyword: Yup.string().max(1024),
    contentSeoDescription: Yup.string().max(1024),

    contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),
  })

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] =
    useState(validationSchema)

  const initialValues = {
    contentId: "",

    // Content
    contentName: "",
    slug: "",
    contentPosition: "",
    contentDetail: "",
    thumbnail: {},
    // contentThumbnail: {},

    contentSeoTitle: "",
    contentSeoKeyword: "",
    contentSeoDescription: "",
    contentUpdateDate: moment().format("YYYY-MM-DD"),
    contentStatus: "active",
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log(`🚀 ~ ${_pageName} Create ~ values:`, values)
      const payload = {
        id: qMainId,
        contentId: values.contentId ? values.contentId : undefined,
        langId: qLang,
        contentName: values.contentName,
        slug: values.slug.replace(/-+$/, ''),
        contentPosition: values.contentPosition,
        contentDetail: values.contentDetail,

        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        attachmentData: {
          
        },

        contentAttachmentData: {
          thumbnail: values.thumbnail,
        },
      }

      const pageDetailRoute = {
        mainId: pageDetail?.data?.mainId,
        contentPageName: values.contentName,
        slug: `detail/${values.slug.replace(/-+$/, '')}`,
        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        componentKey: componentKey,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,
        _parentComponent: _parentComponent,
      };

      console.log("🚀 ~ onSave ~ payload:", payload)

      setWaitSendData(true)
      if (pageView === "update") {
        API.fetchUpdateContent(payload, pageDetailRoute)
      } else {
        API.fetchCreateContent(payload, pageDetailRoute)
      }
    },
  })

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("contentName", resData?.contentName ?? "")
    validation.setFieldValue("slug", resData?.slug.replace('detail/') ?? "")
    validation.setFieldValue("contentPosition", resData?.contentPosition ?? "")
    validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")

    validation.setFieldValue("thumbnail", resData?.contentThumbnail ?? "")

    validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
    validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")
    validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD"))
    validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")

    setContentDetail(resData)
    setPrefillComplete(true)
  }

  const API = {
    fetchGetPageDetail: async (componentKey, slug) => {
      const response = await SearchPageDetail(componentKey, {
        lang: qLang,
        params: {
          slug: slug
        }
      })

      if (response.status == 200) {
        setPageDetail(response.data)
      }
    },
    fetchGetContentById: async payload => {
      try {
        const response = await GetBoardsById({
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          preFilInput(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong 001",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setContentLoading(false)
      }
    },
    fetchCreateContent: async (payload, pageDetailRoute) => {
      try {
        const responseP = await SavePageDetail(componentKey, { data: pageDetailRoute, lang: qLang })
        const response = await CreateBoards({ data: payload, lang: qLang })
        const resData = response.data
        if (resData.status == 201 && responseP.status == 201) {
          mAlert.info({
            title: "Alert",
            subTitle: "Created Data Success",
            content: "",
            onClose: () => {
              navigate(`/${_routeLink}/${qLang}/edit/${resData.data.mainId}`)
              window.location.reload()
            },
          })
        }
      } catch (e) {
        console.log(e)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
    fetchUpdateContent: async (payload, pageDetailRoute) => {
      try {
        const responseP = await UpdatePageDetail(componentKey, { data: pageDetailRoute, lang: qLang })
        const response = await UpdateBoards({
          data: payload,
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 202 && responseP.status == 202) {
          mAlert.info({
            title: "Alert",
            subTitle: "Update Data Success",
            content: "",
            onClose: () => {
              navigate(
                // `/${_routeLink}/${qLang}/edit/${qMainId}`
                window.location.reload()
              )
            },
          })
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
    fetchCreatePreview: async (payload) => {
      try {
        const response = await CreatePreview({ data: payload, lang: qLang })
        const resData = response.data
        if (resData.status == 201) {
          window.open(`${process.env.REACT_APP_FRONTWEB_URL}/preview/executives-and-boards/${resData.data.uuid}`, "_blank")
        }
      } catch (e) {
        console.log(e)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitCreatePreview(false)
      }
    },
  }

  const handlePreview = async (e) => {
    setWaitCreatePreview(true)
    const payload = {
      contentName: validation.values.contentName,
      contentPosition: validation.values.contentPosition,
      contentDetail: validation.values.contentDetail,

      contentSeoTitle: validation.values.contentSeoTitle,
      contentSeoKeyword: validation.values.contentSeoKeyword,
      contentSeoDescription: validation.values.contentSeoDescription,
      contentUpdateDate: validation.values.contentUpdateDate,
      contentStatus: validation.values.contentStatus,

      attachmentData: {
        thumbnail: validation.values.thumbnail,
      },

      contentAttachmentData: {},

      componentKey: componentKey,
      _parentComponent: _parentComponent
    }

    const _rsPreview = await API.fetchCreatePreview(payload)
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id: qMainId }
      setContentLoading(true)
      API.fetchGetContentById(payload)
    }
  }, [qLang])

  useEffect(() => {
    if (["update", "view"].includes(pageView) && prefillComplete && Object.keys(contentDetail).length > 0) {
      const _pageDetail = API.fetchGetPageDetail(componentKey, `detail/${contentDetail?.slug}`)
      setPageDetail(_pageDetail)
    }
  }, [prefillComplete, contentDetail])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: "10px",
    border: "1px solid black",
    margin: "5px",
    borderRadius: "8px",
    background: "#f9f9f9",
    transition: "transform 0.2s ease, background-color 0.3s ease",
  }

  const mapValues = (list = []) =>
    list.map(item => {
      const newObj = {
        attachmentId: item.attachmentId,
        sequence: item.sequence,
      }
      return newObj
    })
  
  if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
      return <Error401 />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={`${PAGE_VIEW} ${_pageName}`}
            breadcrumbItems={[
              { title: _pageName, link: "" },
              { title: PAGE_VIEW },
            ]}
          />

          {/* Render Form */}
          {
            contentLoading
              ? <Spinners setLoading={setContentLoading} />
              :
              <Row>
                <Col className="col-12">
                  <FormikProvider value={validation}>
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <Row>
                        <Col className="col-8">
                          <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                              <i className="bx bx-cube-alt"></i> Information Box
                            </h5>
                            <CardBody>
                              <Row>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="contentName"
                                    className="col-md-12 col-form-label"
                                  >
                                    Full Name
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="contentName"
                                      className="form-control"
                                      type="text"
                                      placeholder=""
                                      name="contentName"
                                      onChange={e => {
                                        validation.setFieldValue(
                                          "contentName",
                                          e.target.value
                                        )
                                        validation.setFieldValue(
                                          "contentSeoTitle",
                                          e.target.value
                                        )
                                      }}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.contentName}
                                      invalid={
                                        validation.touched.contentName &&
                                          validation.errors.contentName
                                          ? true
                                          : false
                                      }
                                      disabled={pageView === "view"}
                                    />
                                    {validation.touched.contentName &&
                                      validation.errors.contentName && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.contentName}
                                        </FormFeedback>
                                      )}
                                  </div>
                                  <hr />
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="contentPosition"
                                    className="col-md-12 col-form-label"
                                  >
                                    Position
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    {/* <Input
                                      id="contentPosition"
                                      className="form-control"
                                      type="text"
                                      placeholder=""
                                      name="contentPosition"
                                      onChange={e => {
                                        validation.setFieldValue(
                                          "contentPosition",
                                          e.target.value
                                        )
                                      }}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.contentPosition}
                                      invalid={
                                        validation.touched.contentPosition &&
                                          validation.errors.contentPosition
                                          ? true
                                          : false
                                      }
                                      disabled={pageView === "view"}
                                    />
                                    {validation.touched.contentPosition &&
                                      validation.errors.contentPosition && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.contentPosition}
                                        </FormFeedback>
                                      )} */}
                                    <MyEditor
                                      id="contentPosition"
                                      placeholder=""
                                      name="contentPosition"
                                      onChange={(e, editor) => {
                                        const data = editor.getData()
                                        validation.setFieldValue(
                                          "contentPosition",
                                          data
                                        )
                                        console.log({ e, editor, data })
                                      }}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.contentPosition}
                                      invalid={
                                        validation.touched.contentPosition &&
                                          validation.errors.contentPosition
                                          ? true
                                          : false
                                      }
                                      isError={
                                        validation.touched.contentPosition &&
                                            validation.errors.contentPosition
                                            ? true
                                            : false
                                      }
                                      onReady={(editor) => {
                                        editor.editing.view.change((writer) => {
                                          writer.setStyle(
                                            "height",
                                            "70px !important",
                                            editor.editing.view.document.getRoot()
                                          );
                                        });
                                      }}
                                      disabled={pageView === "view"}
                                    />
                                  </div>
                                  <hr />
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="slug"
                                    className="col-md-12 col-form-label"
                                  >
                                    Slug
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="slug"
                                      className="form-control"
                                      type="text"
                                      placeholder=""
                                      name="slug"
                                      onChange={e => {
                                        validation.setFieldValue(
                                          "slug",
                                          slugify(e.target.value)
                                        )
                                      }}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.slug}
                                      invalid={
                                        validation.touched.slug &&
                                          validation.errors.slug
                                          ? true
                                          : false
                                      }
                                      disabled={pageView === "view"}
                                    />
                                    {validation.touched.slug &&
                                      validation.errors.slug && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.slug}
                                        </FormFeedback>
                                      )}
                                  </div>
                                  <hr />
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="contentDetail"
                                    className="col-md-12 col-form-label"
                                  >
                                    Details
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <MyEditor
                                      id="contentDetail"
                                      placeholder=""
                                      name="contentDetail"
                                      onChange={(e, editor) => {
                                        const data = editor.getData()
                                        validation.setFieldValue(
                                          "contentDetail",
                                          data
                                        )
                                        console.log({ e, editor, data })
                                      }}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.contentDetail}
                                      invalid={
                                        validation.touched.contentDetail &&
                                          validation.errors.contentDetail
                                          ? true
                                          : false
                                      }
                                      isError={
                                        validation.touched.contentDetail &&
                                            validation.errors.contentDetail
                                            ? true
                                            : false
                                      }
                                      disabled={pageView === "view"}
                                    />
                                  </div>
                                  <hr />
                                </Col>
                                <Col className="col-6 mb-3">
                                  {/* {JSON.stringify(validation.values.thumbnail)} */}
                                  <div className="col-md-12">
                                    <PopupAttachment
                                      typeDetail="single"
                                      typeUpload="ImageMap"
                                      upload="Image"
                                      prefixName="executives-thumbnail"
                                      label={`${_pageName} Thumbnail`}
                                      required={true}
                                      description="description"
                                      widthSize={576}
                                      heightSize={480}
                                      value={validation.values.thumbnail}
                                      onChange={(value = {}, index) => {
                                        console.log("🚀 onChange ~ value:", value)
                                        console.log("🚀 onChange ~ index:", index)
                                        validation.setFieldValue("thumbnail", value)
                                      }}
                                      onRemove={index => {
                                        console.log("🚀 onChange ~ index:", index)
                                        validation.setFieldValue("thumbnail", {})
                                      }}
                                    />
                                    {validation.touched.thumbnail &&
                                      validation.errors.thumbnail && (
                                        <div
                                          type="invalid"
                                          className="invalid-feedback d-block"
                                        >
                                          {validation.errors.thumbnail}
                                        </div>
                                      )}
                                  </div>
                                  <hr />
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col className="col-4">
                          <Card
                            outline
                            color="primary"
                            className="border sticky-element"
                          >
                            <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                              <i className="bx bx-check"></i> Tools Box
                            </h5>
                            <CardBody>
                              <Row>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Switch Language
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <InputLang
                                      widthfull
                                      pageView={pageView}
                                      forceRoute={false}
                                    />
                                  </div>
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Written at
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <InputGroup>
                                      <Flatpickr
                                        className="form-control d-block"
                                        options={{
                                          dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                        }}
                                        value={
                                          validation.values.contentUpdateDate
                                            ? moment(
                                              validation.values.contentUpdateDate,
                                              "YYYY-MM-DD"
                                            ).toDate()
                                            : null
                                        }
                                        disabled={true}
                                      />
                                      <div className="input-group-append">
                                        <button
                                          type="button"
                                          className="btn btn-outline-secondary docs-datepicker-trigger"
                                          disabled
                                        >
                                          <i
                                            className="fa fa-calendar"
                                            aria-hidden="true"
                                          />
                                        </button>
                                      </div>
                                    </InputGroup>
                                    {validation.touched.contentUpdateDate &&
                                      validation.errors.contentUpdateDate && (
                                        <div
                                          type="invalid"
                                          className="invalid-feedback d-block"
                                        >
                                          {validation.errors.contentUpdateDate}
                                        </div>
                                      )}
                                  </div>
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Display
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <Select
                                      placeholder="Select Status"
                                      value={fn_helper.FNFORM.getObjectValue(
                                        STATUS_OPTION,
                                        `${validation.values.contentStatus}`
                                      )}
                                      onChange={value =>
                                        validation.setFieldValue(
                                          "contentStatus",
                                          value.id
                                        )
                                      }
                                      getOptionValue={option => option.id}
                                      getOptionLabel={option => option.name}
                                      options={STATUS_OPTION}
                                      className={`select2-selection ${validation.touched.contentStatus &&
                                        validation.errors.contentStatus
                                        ? "input-err"
                                        : ""
                                        }`}
                                      isDisabled={pageView === "view"}
                                    />
                                    {validation.touched.contentStatus &&
                                      validation.errors.contentStatus && (
                                        <div
                                          type="invalid"
                                          className="invalid-feedback d-block"
                                        >
                                          {validation.errors.contentStatus}
                                        </div>
                                      )}
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                            <CardFooter>
                              <Row>
                                <Col className="text-start">
                                  <Button
                                    color="danger"
                                    className="btn btn-danger"
                                    onClick={() =>
                                      navigate(`/${_routeLink}/${qLang}`)
                                    }
                                  >
                                    Back
                                  </Button>
                                </Col>
                                <Col className="text-end">
                                  <Button
                                    className="btn btn-block btn-primary"
                                    onClick={handlePreview}
                                  >
                                    Preview{" "}
                                    {waitCreatePreview ? (
                                      <Spinner size="sm" color="light" />
                                    ) : null}
                                  </Button>
                                  &nbsp;
                                  {pageView !== "view" && (
                                    <Button
                                      type="submit"
                                      className="btn btn-success"
                                    >
                                      Save {waitSendData ? <Spinner size="sm" color="light" /> : null}
                                    </Button>
                                  )}
                                </Col>
                              </Row>
                            </CardFooter>
                          </Card>
                        </Col>
                        <Col className="col-12">
                          <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                              <i className="bx bx-trending-up"></i> SEO Box
                            </h5>
                            <CardBody>
                              <Row className="">
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Meta Title
                                    {/* <span className="t-require">*</span> */}
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="contentSeoTitle"
                                      className="form-control"
                                      type="text"
                                      placeholder="Page Title"
                                      name="contentSeoTitle"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.contentSeoTitle}
                                      invalid={
                                        validation.touched.contentSeoTitle &&
                                          validation.errors.contentSeoTitle
                                          ? true
                                          : false
                                      }
                                      disabled={pageView === "view"}
                                    />
                                    {validation.touched.contentSeoTitle &&
                                      validation.errors.contentSeoTitle && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.contentSeoTitle}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Meta Description
                                    {/* <span className="t-require">*</span> */}
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="contentSeoDescription"
                                      className="form-control"
                                      type="text"
                                      placeholder="SEO Description"
                                      name="contentSeoDescription"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.contentSeoDescription
                                      }
                                      invalid={
                                        validation.touched.contentSeoDescription &&
                                          validation.errors.contentSeoDescription
                                          ? true
                                          : false
                                      }
                                      disabled={pageView === "view"}
                                    />
                                    {validation.touched.contentSeoDescription &&
                                      validation.errors.contentSeoDescription && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.contentSeoDescription}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Meta Keywords
                                    {/* <span className="t-require">*</span> */}
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="contentSeoKeyword"
                                      className="form-control"
                                      type="text"
                                      placeholder="SEO Keywords"
                                      name="contentSeoKeyword"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.contentSeoKeyword}
                                      invalid={
                                        validation.touched.contentSeoKeyword &&
                                          validation.errors.contentSeoKeyword
                                          ? true
                                          : false
                                      }
                                      disabled={pageView === "view"}
                                    />
                                    {validation.touched.contentSeoKeyword &&
                                      validation.errors.contentSeoKeyword && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.contentSeoKeyword}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </Col>
              </Row>
          }
        </Container>
      </div>
    </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(BoardTemplate)
